import React from 'react'
import './ProgressBar.css'

export default function ProgressBar({ num }) {
	let startNumber = num
	const endNumber = 10

	function renderPercentage(progress) {
		const percent = 100 - progress * 100
		if (percent < 0) {
			return 0
		} else {
			return percent
		}
	}

	return (
		<div className='progress-layout'>
			<div className='progress-wrap'>
				<div className='progress-bar-container'>
					<div
						className='progress-bar-value'
						style={{ width: `${renderPercentage(startNumber / endNumber)}%` }}
					/>
				</div>
			</div>
		</div>
	)
}
